import { Typography } from 'antd'
import { TimepointTask, ExtraTask } from '../types/municipalityData'

export interface SelectionDescriptionProps {
  task: TimepointTask | ExtraTask
}

export const SelectionDescription = ({ task }: SelectionDescriptionProps) => {
  return (
    <div>
      {Object.entries(task.selectionDescriptions).map(([level, desc], index) => (
        <div key={level} style={{ whiteSpace: 'pre-line', marginBottom: index === 0 ? 10 : 2 }}>
          <Typography.Text strong>{level}: </Typography.Text>
          {desc}
        </div>
      ))}
    </div>
  )
}
